export interface RecentHotelEntry {
  uuid: string;
  lastVisitedAt: number;
}

export const RECENT_HOTELS_LIMIT = 10;

export function parseRecentHotels(rawValue: string | null) {
  let value: unknown = [];

  try {
    value = JSON.parse(rawValue ?? '[]');
  } catch {
    // Invalid storage falls back to an empty recent-hotel list.
  }

  return (Array.isArray(value) ? value : [])
    .filter(
      (entry): entry is RecentHotelEntry =>
        typeof entry?.uuid === 'string' &&
        typeof entry?.lastVisitedAt === 'number'
    )
    .sort((a, b) => b.lastVisitedAt - a.lastVisitedAt)
    .slice(0, RECENT_HOTELS_LIMIT);
}

export function recentHotelUuids(
  entries: RecentHotelEntry[],
  accessibleHotelUuids: string[]
) {
  const accessibleHotelUuidSet =
    accessibleHotelUuids.length > 0 ? new Set(accessibleHotelUuids) : null;

  return entries
    .map(({ uuid }) => uuid)
    .filter(
      (uuid) => !accessibleHotelUuidSet || accessibleHotelUuidSet.has(uuid)
    )
    .slice(0, RECENT_HOTELS_LIMIT);
}

export function rememberRecentHotel(
  entries: RecentHotelEntry[],
  uuid: string,
  lastVisitedAt: number
) {
  return [
    { uuid, lastVisitedAt },
    ...entries.filter((entry) => entry.uuid !== uuid),
  ].slice(0, RECENT_HOTELS_LIMIT);
}

export function pruneRecentHotels(
  entries: RecentHotelEntry[],
  validUuids: string[]
) {
  const validUuidSet = new Set(validUuids);

  return entries.filter(({ uuid }) => validUuidSet.has(uuid));
}
